import { Relation } from "@nozbe/watermelondb";
import { field, json, relation, text } from "@nozbe/watermelondb/decorators";
import {
  LayoutNodeActionType,
  LayoutNodeFilter,
  LayoutNodeLink,
} from "@towersystems/roam-common/lib/generated-types";
import { noopSanitizeJSON } from "../utils";
import { BaseModel } from "./Base";
import Product from "./Product";
import { Associations } from "@nozbe/watermelondb/Model";
import Layout from "./Layout";

export default class LayoutNode extends BaseModel {
  static table = "layout_nodes";

  static associations: Associations = {
    layout: { type: "belongs_to", key: "layout_id" },
  };

  @relation("layouts", "layout_id") layout: Relation<Layout>;

  @text("label") label: string | null;
  @text("color") color: string | null;
  @text("image_url") imageUrl: string | null;
  @text("product_id") productId: string | null;
  @text("show_image") showImage: boolean;
  @text("type") type: string | null;
  @field("position") position: number;
  @text("action") action: LayoutNodeActionType | null;
  @json("link", noopSanitizeJSON) link: LayoutNodeLink | null;
  @json("filter", noopSanitizeJSON) filter: LayoutNodeFilter | null;
  @relation("products", "product_id") product: Relation<Product>;
  @text("label_color") labelColor: string | null;
}
